import {useState} from 'react'

import { exportDocToMember, fetchDocsByMember } from '../connections/requests';
import { useQuery } from 'react-query';
import { Button, Container, FileInput,Text,Table, Paper, UnstyledButton, Title, Grid } from '@mantine/core';
import { IconFolder, IconNotebook } from '@tabler/icons-react';

export default function DocList({membre}) {
  const { data } = useQuery(['memberdocs', membre], fetchDocsByMember);
  const [value, setValue] = useState();
  return (
    <Container>
      <Grid my={"lg"} >
        <Grid.Col span={5}>
          <FileInput  
          value={value} onChange={setValue}
          placeholder="Sélectionner le fichier"
          label="Ajouter un fichier"
          withAsterisk/>
        </Grid.Col>
        <Grid.Col span={2}>
          <Button my={"lg"} onClick={()=> exportDocToMember(value,membre)}>Téléverser</Button>
        </Grid.Col>
      </Grid>
    <Title my={"md"}  ta={"center"} order={3}>Dossier du membre</Title>
      <Paper>
      <Table>
        <tbody>
          {data ? data.map((f,i)=> <DocRow item={f} index={i}/>):null}
        </tbody>
      </Table>
      </Paper>
    </Container>
  )
}

function DocRow({item,index}){
  return (
    <tr><td>{item.folder ? <IconFolder/>: item.file ? <IconNotebook/>:null}</td><td><UnstyledButton component={"a"} href={item.url} target='_blank'><Text>{item.name}</Text></UnstyledButton></td><td><Text>Créé le {new Date(item.creation).toLocaleDateString("fr-CA")}</Text></td><td>{item.size ? `${(item.size/1000000).toPrecision(2)} Mb`:null}</td></tr>
  )
}
